import { useMutation } from '@apollo/client'
import { UPDATE_ORDER_EXTERNAL_CODE, GET_ORDER_BY_ID } from '../OrderQueries'
import { EditableTextField } from '@/components/shared/EditableTextField'
import { toast } from 'sonner'

interface EditableExternalOrderCodeProps {
  orderId: string
  currentValue: string | null
}

export function EditableExternalOrderCode({
  orderId,
  currentValue,
}: EditableExternalOrderCodeProps) {
  const [updateExternalCode] = useMutation(UPDATE_ORDER_EXTERNAL_CODE, {
    refetchQueries: [
      {
        query: GET_ORDER_BY_ID,
        variables: { id: orderId },
      },
    ],
    onCompleted: () => {
      toast.success('External order code updated successfully')
    },
    onError: error => {
      toast.error(`Failed to update external order code: ${error.message}`)
    },
  })

  const handleSave = async (newValue: string | null) => {
    await updateExternalCode({
      variables: {
        where: { id: orderId },
        order_external_code: newValue,
      },
    })
  }

  return <EditableTextField value={currentValue} onSave={handleSave} />
}
